import util from "@/common/util";
import { iDashBoard, iProject, iTask } from "@/services";

const state = {
  taskFlag: false, // 선택한 프로젝트에 작업이 존재하면 true, 없으면 false
  currentId: "",
  currentType: "",
  currentObject: {},

  panelTreeProjects: [],
  currentPanelTreeTasks: [],
  totalProjectCount: 0,
  isTreeSearched: false,

  projectDetail: {},
  workDetail: {},

  project: {
    id: 0,
    name: "",
    startDate: "",
    endDate: "",
    description: "",
    createUser: {
      name: "",
      email: "",
    },
    managers: [],
    supervisors: [],
    inspectorCount: 0,
    managerCount: 0,
    doneItemCount: 0,
    operatorCount: 0,
    supervisorCount: 0,
    isProjectCompleted: false,
    targetWorkloadType: "",
    targetWorkload: 0,
    taskCount: 0,
    taskItemCount: 0,
    isSatisfed: false,
    status: 0,
    canRestartProject: false,
    currentWorkload: 0,
  },
  taskPriceGroupId: 0, // 선택한 작업의 단가 그룹 ID

  requests: [],
  isRequesting: false,

  taskRoles: [],

  hasContract: false,
};

const mutations = {
  setTaskFlag: (state, data) => {
    state.taskFlag = data;
  },
  setPanelTreeProjects: (state, data) => {
    state.panelTreeProjects = data;
  },
  setCurrentPanelTreeTasks: (state, data) => {
    state.currentPanelTreeTasks = data;
  },
  setIsTreeSearched: (state, data) => {
    state.isTreeSearched = data;
  },
  setTotalProjectCount: (state, data) => {
    state.totalProjectCount = data;
  },
  setCurrentProject: (state, data) => {
    state.currentId = data.id;
    state.currentType = "project";
    state.currentName = data.name;

    state.currentObject = {
      currentType: "project",
      currentName: data.name,
      currentId: data.id,
      projectId: data.id,
      projectName: data.name,
      isAdmin: data.isAdmin,
    };

    state.hasContract = Boolean(
      data.abbreviatedContractTemplateId && data.basicContractTemplateId
    );

    // set aside project detail
    const printType = { ITEM: "파일", OBJECT: "객체" };
    const workload =
      data.targetWorkload > 0
        ? `${printType[data.targetWorkloadType]} ${util.comma(
            data.targetWorkload
          )}개`
        : "-";
    state.projectDetail = {
      createUser: data.createUser.name + " (" + data.createUser.email + ")",
      description: data.description,
      date:
        util.dateFormat(data.startDate) + " ~ " + util.dateFormat(data.endDate),
      fileCount: data.taskItemCount,
      workCount: data.taskCount,
      persons: {
        manager: data.managerCount,
        supervisor: data.supervisorCount,
        worker: data.operatorCount,
        inspector: data.inspectorCount,
      },
      workload,
    };
  },
  setCurrentTask: (state, data) => {
    state.currentId = data.id;
    state.currentType = "work";
    state.currentName = data.name;

    state.currentObject = {
      currentType: "work",
      currentId: data.id,
      projectId: data.projectId,
      projectName: data.projectName,
      taskId: data.id,
      workName: data.name,
      currentName: data.name,
      isAdmin: data.isAdmin,
      hasSet: data.hasSet,
    };

    // set aside work detail
    state.workDetail = {
      createUser: data.createUser.name,
      createDate: data.createDate?.slice(0, 10),
      datasetPath: data.datasetPath,
      fileCount: data.taskItemCount,
      interface: data.interfaceName,
      interfaceId: data.interfaceId,
      manualUrl: data.manualUrl,
      persons: {
        worker: data.operatorCount,
        inspector: data.inspectorCount,
      },
    };
  },

  setProject: (state, data) => {
    state.project.id = data.id;
    state.project.name = data.name;
    state.project.startDate = data.startDate;
    state.project.endDate = data.endDate;
    state.project.description = data.description;
    state.project.createUser = data.createUser;
    state.project.managers = data.managers;
    state.project.supervisors = data.supervisors;
    state.project.inspectorCount = data.inspectorCount;
    state.project.managerCount = data.managerCount;
    state.project.doneItemCount = data.doneItemCount;
    state.project.operatorCount = data.operatorCount;
    state.project.supervisorCount = data.supervisorCount;
    state.project.isProjectCompleted = data.isProjectCompleted;
    state.project.targetWorkloadType = data.targetWorkloadType;
    state.project.targetWorkload = data.targetWorkload;
    state.project.taskCount = data.taskCount;
    state.project.taskItemCount = data.taskItemCount;
    state.project.isSatisfed = data.isSatisfed;
    state.project.status = data.status;

    state.project.canRestartProject = data.canRestartProject;
    state.project.currentWorkload = data.currentWorkload;
  },
  setTaskGroupId: (state, data) => {
    state.taskPriceGroupId = data;
  },
  setTaskRoles: (state, data) => {
    state.taskRoles = data;
  },

  SET_RESTART_TARGET_WORKLOAD: (state, data) => {
    const printType = { ITEM: "파일", OBJECT: "객체" }[data.targetWorkloadType];
    const workload = `${printType} ${util.comma(data.targetWorkload)}개`;

    state.projectDetail.workload = workload;
    state.project.targetWorkload = data.targetWorkload;
    state.project.targetWorkloadType = data.targetWorkloadType;

    state.currentObject.canRestartProject = false;
    state.project.canRestartProject = false;
    state.project.isSatisfed = false;
  },

  ADD_REQUEST: (state, data) => {
    state.requests.push(data.payload);
  },
  SHIFT_REQUEST: (state) => {
    state.requests.shift();
  },
  SET_CLEAR_LESS_REQUESTS: (state) => {
    const current = state.requests.at(0);
    const last = state.requests.at(-1);
    state.requests = [current, last];
  },
  SET_REQUESTING: (state, data) => {
    state.isRequesting = data;
  },

  clearDashboard: (state) => {
    state.taskFlag = false;
    state.currentId = "";
    state.currentType = "";
    state.currentObject = {};
    state.totalProjectCount = 0;
    state.projectDetail = {};
    state.workDetail = {};
    state.project = {};
    state.taskPriceGroupId = 0;
    state.requests = [];
    state.isRequesting = false;
    state.taskRoles = [];
    state.hasContract = false;
  },
};

const actions = {
  async handleRequest({ state, commit, dispatch }, payload) {
    commit("SET_REQUESTING", true);

    if (state.totalProjectCount <= 0 || !payload.currentId) {
      return;
    }

    let project = {};
    let task = {};

    switch (payload.currentType) {
      case "project": {
        commit("setTaskRoles", []);

        const pRes = await iProject.getProjectDetail({ id: payload.currentId });
        project = pRes.data?.project;
        commit("setCurrentProject", { ...project, isAdmin: payload.isAdmin });
        break;
      }
      case "work": {
        // set task roles
        const taskRoleRes = await iTask.getTaskRoles({
          taskId: payload.currentId,
        });
        commit("setTaskRoles", taskRoleRes.data?.payload.roles);

        const tRes = await iTask.getTaskDetail({ id: payload.currentId });
        task = tRes.data?.payload;
        commit("setCurrentTask", { ...task, isAdmin: payload.isAdmin });

        const pRes = await iProject.getProjectDetail({ id: task.projectId });
        project = pRes.data?.project;
        break;
      }
    }

    // 프로젝트의 관리자인 경우에만 API 요청
    if (payload.isAdmin) {
      const id = project.id;
      const res = await iProject.isProjectWorkResume({ id });
      state.currentObject.canRestartProject = res.data?.possibility;
      project.canRestartProject = res.data?.possibility;
    }

    let projectWorkedCount = 0;
    if (project.targetWorkloadType) {
      const workloadPay = {
        id: project.id,
        targetWorkloadType: project.targetWorkloadType,
      };

      const workloadRes = await iProject.getProjectWorkedCount(workloadPay);
      projectWorkedCount = workloadRes.data?.projectWorkedCount;
    }

    project.currentWorkload = projectWorkedCount;

    commit("setProject", project);
    commit("setTaskGroupId", task.priceGroupId);
    commit("SHIFT_REQUEST");
    if (state.requests.length > 0) {
      await dispatch("handleRequest", state.requests[0]);
    }

    commit("SET_REQUESTING", false);
  },
  async setCurrent({ state, commit, dispatch }, payload) {
    commit("ADD_REQUEST", { payload: structuredClone(payload) });

    // if request queue length more than 2, remove all requests except current and last request.
    if (state.requests.length > 2) {
      commit("SET_CLEAR_LESS_REQUESTS");
    }

    if (state.isRequesting) {
      return;
    }

    await dispatch("handleRequest", payload);
  },

  /** 프로젝트 리스트 조회 */
  async getAsideProjects({ commit, state }, options) {
    try {
      const res = await iDashBoard.getDashboardProjects(options);
      if (res.data.code !== "") {
        console.error(`[ERROR]: ${res.data.code}`);
        return;
      }

      const { panelTreeProjects, totalCount } = res.data.payload;
      commit("setPanelTreeProjects", panelTreeProjects);
      commit("setTotalProjectCount", totalCount);

      if (options.keyword.length) {
        state.isTreeSearched = true;
      } else {
        state.isTreeSearched = false;
      }

      return { panelTreeProjects, totalCount };
    } catch (error) {
      console.error(error);
    }
  },

  /** 작업 리스트 조회 */
  async getAsideTasks(_, projectId) {
    try {
      const res = await iDashBoard.getDashboardTasks(projectId);
      return res.data.payload;
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
